
import React from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./Admintopbar";
import CouponManager from "./CouponManager";
import "../styles/AdminCouponsPage.css";
export default function AdminCouponsPage() {
  return (
    <div className="admin-page-full d-flex">
      <AdminSidebar />

      <div className="admin-content flex-grow-1">
        <AdminTopbar />

        <main className="admin-coupons-page">
          <div className="mb-4">
            <h1>Coupon Management</h1>
            <p>
              Create and manage discount coupons for all MockQ exams
              and eligible subscriptions.
            </p>
          </div>

          <CouponManager />
        </main>
      </div>
    </div>
  );
}
